__webpack_require__.p = "/apps/campsite-explorer/_next/";